import tracking from './api';

async function trackCorreios(trackingCode) {
    try {
        let trackingList = [];
        // const response = await tracking.get(`/consultar/json/${trackingCode}`);
        const response = await tracking.get(`/tracking/${trackingCode}`);

        console.log(response);
        if (response.data.objeto[0].erro) {
            throw new Error(response.data.objeto[0].erro);
        }

        trackingList = response.data.objeto[0].evento;
        return trackingList;
    } catch (err) {
        console.error(err);

        return { error: err.message };
    }
}

export { trackCorreios };
